(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("7GlxI", function(module, exports) {

var $4ltr2 = parcelRequire("4ltr2");
document.querySelectorAll(".c-desc-decoration img").forEach((decoration)=>{
    decoration.src = decoration.src.replace("line_01.svg", `line_0${(0, $4ltr2.getRandomInt)(1, 7)}.svg`);
    decoration.classList.add("--show");
});

});
parcelRegister("4ltr2", function(module, exports) {

$parcel$export(module.exports, "getRandomInt", function () { return $329ff4cde42c8889$export$b141de964f0a90c1; });
function $329ff4cde42c8889$export$b141de964f0a90c1(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

});


})();
//# sourceMappingURL=description-decoration.d8fd8686.js.map
